"use client";

import { useState } from "react";

import { useRouter } from "next/navigation";

import { UserOutlined } from "@ant-design/icons";
import { Building20Filled } from "@fluentui/react-icons";
import { Popover, PopoverContent, PopoverTrigger } from "@heroui/react";

import MenuItem from "./menu-item";
import MyAccountButton from "./my-account-button";

export default function MyAccountDropdown() {
  const router = useRouter();
  const [isOpen, setIsOpen] = useState<boolean>(false);

  return (
    <Popover
      placement="right"
      offset={0}
      isOpen={isOpen}
      onOpenChange={setIsOpen}
    >
      <PopoverTrigger>
        <MyAccountButton />
      </PopoverTrigger>
      <PopoverContent>
        <div className="gap-2 bg-lilac-geode-200 shadow-md">
          <MenuItem
            icon={<Building20Filled />}
            label="Perfil Empresa"
            onClick={() => {
              setIsOpen(false);
              router.push("/profile/company");
            }}
          />
          <MenuItem
            icon={<UserOutlined />}
            label="Meu Perfil"
            onClick={() => {
              setIsOpen(false);
              router.push("/profile");
            }}
          />
        </div>
      </PopoverContent>
    </Popover>
  );
}
